
(function () {
  "use strict";
  var d = document;

  /* reveal on scroll */
  var io = "IntersectionObserver" in window
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 })
    : null;
  function observe(root) {
    (root || d).querySelectorAll(".reveal:not(.is-in)").forEach(function (el) {
      if (io) io.observe(el); else el.classList.add("is-in");
    });
  }
  observe();

  /* sticky header */
  var header = d.querySelector("[data-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-stuck", window.scrollY > 8); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* mobile nav */
  d.addEventListener("click", function (e) {
    var t = e.target.closest("[data-nav-toggle]");
    if (!t) return;
    var nav = d.querySelector("[data-mobile-nav]");
    if (!nav) return;
    var open = nav.classList.toggle("is-open");
    t.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* product gallery */
  d.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main]");
    g.addEventListener("click", function (e) {
      var b = e.target.closest("[data-gallery-thumb]");
      if (!b || !main) return;
      main.src = b.getAttribute("data-full");
      main.alt = b.getAttribute("data-alt") || main.alt;
      g.querySelectorAll("[data-gallery-thumb]").forEach(function (x) { x.setAttribute("aria-current", "false"); });
      b.setAttribute("aria-current", "true");
    });
  });

  /* quantity */
  d.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty]");
    if (!b) return;
    var input = b.parentNode.querySelector("input");
    var v = parseInt(input.value, 10) || 1;
    v += b.getAttribute("data-qty") === "up" ? 1 : -1;
    input.value = Math.max(1, v);
  });

  /* variant picker */
  var formWrap = d.querySelector("[data-variant-form]");
  var form = formWrap && formWrap.querySelector("form");
  if (form) {
    var data = d.getElementById("VariantData");
    var variants = data ? JSON.parse(data.textContent) : [];
    var idInput = form.querySelector("[data-variant-id]");
    var priceNow = d.querySelector("[data-price-now]");
    var priceWas = d.querySelector("[data-price-was]");
    var addBtn = form.querySelector("[data-add]");
    var buyBtn = form.querySelector("[data-buy]");
    function money(cents) {
      var fmt = formWrap.getAttribute("data-money") || "${{amount}}";
      var value = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
    }
    function update() {
      var chosen = Array.prototype.map.call(form.querySelectorAll("[data-option-index]:checked"), function (i) { return i.value; });
      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
      if (!match) return;
      idInput.value = match.id;
      if (priceNow) priceNow.textContent = money(match.price);
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = money(match.compare_at_price);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }
      [addBtn, buyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !match.available;
      });
      if (addBtn) addBtn.textContent = match.available ? addBtn.getAttribute("data-label") : "Sold out";
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        history.replaceState({}, "", url.toString());
      }
    }
    form.addEventListener("change", function (e) { if (e.target.matches("[data-option-index]")) update(); });
  }

  /* mobile sticky buy bar */
  var bar = d.querySelector("[data-buybar]");
  var anchor = d.querySelector("[data-buy-anchor]");
  if (bar && anchor && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      bar.classList.toggle("is-visible", !es[0].isIntersecting);
    }, { threshold: 0 }).observe(anchor);
  }

  /* lazy videos: only autoplay when visible */
  if ("IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.paused) v.play().catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.25 });
    d.querySelectorAll("video[data-autoplay]").forEach(function (v) { vio.observe(v); });
  }
})();
